import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { paletteTokens } from '@oasis/theme';
import { buttonTokens } from './theme-components/button';
import { tooltipTokens } from './theme-components/tooltip';
export const presetOptions = {
    primitive: {
        ...paletteTokens,
        // Alias kept here rather than in the shared palette: `palette()` is a
        // PrimeVue construct, and the token package is deliberately UI-library
        // agnostic so non-PrimeVue consumers can use it.
        gray: palette('{grey}')
    },
    semantic: {
        primary: palette('{blue}'),
        success: palette('{green}'),
        warn: palette('{yellow}'),
        danger: palette('{red}'),
        colorScheme: {
            light: {
                surface: palette('{grey}'),
                primary: {
                    color: '{primary.300}',
                    inverseColor: '{white}',
                    hoverColor: '{blue.500}',
                    activeColor: '{navy.700}',
                },
                highlight: {
                    color: '{primary.600}',
                    focusColor: '{primary.800}',
                    background: '{primary.50}',
                    focusBackground: '{primary.300}',
                },
                content: {
                    color: '{text.color}',
                    hoverColor: '{text.hover.color}',
                    background: '{surface.0}',
                    hoverBackground: '{primary.100}',
                    borderColor: '{surface.300}',
                },
                text: {
                    color: '{navy.600}',
                    hoverColor: '{primary.hover.color}',
                    mutedColor: '{grey.500}',
                    hoverMutedColor: '{primary.400}'
                },
                navigation: {
                    item: {
                        color: '{navy.700}',
                        childColor: '{text.color}',
                        activeColor: '{cyan.900}',
                        focusBackground: '{surface.100}',
                        activeBackground: '{highlight.background}',
                        hoverParentBackground: '{slate.100}',
                        activeParentBackground: '{grey.50}',
                        focusColor: '{text.color}',
                        fontSize: '0.875rem',
                        activeFontWeight: '600'
                    },
                    group: {
                        borderColor: '{slate.100}'
                    },
                    overlay: {
                        background: '{slate.600}'
                    }
                }
            }
        },
        focusRing: {
            width: '2px',
            style: 'solid',
            color: '{navy.700}',
            offset: '1px'
        }
    },
    components: {
        button: buttonTokens,
        tooltip: tooltipTokens
    }
};
export const preset = definePreset(Aura, presetOptions);
export const theme = {
    preset,
    options: {
        darkModeSelector: '.layout-dark',
        cssLayer: {
            name: 'primevue',
            order: 'theme, base, primevue'
        }
    }
};
